import get from 'lodash.get';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useGetSellerProviderName = () => {
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const labelProviders = useSelector(Global.selectReferenceDatagetProviders);

  const getSellerProviderName = (sellerLabelProvider) => {
    if (!sellerLabelProvider) {
      return '';
    }

    if (!sellerLabelProvider.name) {
      const hasMultiples =
        sellerLabelProviders.filter((provider) => provider.labelProviderId === sellerLabelProvider.labelProviderId).length > 1;
      const matchingLabelProvider = labelProviders.find((provider) => provider.labelProviderId === sellerLabelProvider.labelProviderId);

      const matchingLabelProviderName = get(matchingLabelProvider, 'name', '');
      const sellerLabelProviderAccountNumber = get(sellerLabelProvider, 'accountNumber', '');

      if (!hasMultiples) {
        return matchingLabelProviderName;
      }
      return `${matchingLabelProviderName} (${sellerLabelProviderAccountNumber})`;
    }

    const matchingLabelProvider = labelProviders.find((provider) => provider.labelProviderId === sellerLabelProvider.labelProviderId);
    const matchingLabelProviderName = get(matchingLabelProvider, 'name', '');

    if (sellerLabelProvider.useHouseCredentials) {
      return matchingLabelProviderName;
    }
    return `${matchingLabelProviderName} - ${sellerLabelProvider.name}`;
  };

  return getSellerProviderName;
};
